import React, { createContext, useContext } from 'react';

interface ApiConfig {
  endpoint: string;
  key: string;
}

interface ApiContextValue {
  config: ApiConfig;
  // TODO: Add API service methods
  createEvent: (data: any) => Promise<any>;
  updateEvent: (id: string, data: any) => Promise<any>;
  checkDuplicates: (data: any) => Promise<any[]>;
}

const ApiContext = createContext<ApiContextValue | null>(null);

interface ApiProviderProps {
  children: React.ReactNode;
  config: ApiConfig;
}

export const ApiProvider: React.FC<ApiProviderProps> = ({
  children,
  config,
}) => {
  // API methods (stubs for now)
  const createEvent = async (data: any) => {
    console.log('Creating event:', data);
    // TODO: Implement actual API call
    return Promise.resolve({ id: 'new-event-id', ...data });
  };
  
  const updateEvent = async (id: string, data: any) => {
    console.log('Updating event:', id, data);
    // TODO: Implement actual API call
    return Promise.resolve({ id, ...data });
  };
  
  const checkDuplicates = async (data: any) => {
    console.log('Checking duplicates:', data);
    // TODO: Implement actual API call
    return Promise.resolve([]);
  };
  
  const value: ApiContextValue = {
    config,
    createEvent,
    updateEvent,
    checkDuplicates,
  };
  
  return (
    <ApiContext.Provider value={value}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApi = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApi must be used within ApiProvider');
  }
  return context;
};
